import React from 'react'

import { TagStyle, TagProps } from './Tag.types'

//TODO: check if we still need this component
export const defaultStyle: TagStyle = {
  colorScheme: {
    primary: 'color-scheme-primary',
    secondary: 'color-scheme-secondary'
  },
  textPosition: {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  }
}

const Tag = ({
  applyBase = true,
  children,
  colorScheme = 'primary',
  textPosition = 'left',
  className = ''
}: TagProps) => {
  const cssClasses: string[] = applyBase
    ? [
        'tag',
        defaultStyle.colorScheme[colorScheme],
        defaultStyle.textPosition[textPosition],
        className
      ]
    : [className]

  return <span className={cssClasses.join(' ')}>{children}</span>
}

export default Tag
